(() => {
    let cloudSwiperInstance;

    const SWIPER_SELECTOR = '.ft-cloud__carousel';
    const mq = window.matchMedia('(min-width: 960px)');

    const updateSlide = (swiper) => {
        const isCenteredSlide = swiper.params.centeredSlides;

        if (isCenteredSlide && swiper.slides.length <= 1) {
            swiper.params.centeredSlides = false;
        }
    }

    const initCloudSwiper = () => {
        const swiperEl = document.querySelector(SWIPER_SELECTOR);
        if (!swiperEl) return;

        if (mq.matches) {
            if (!cloudSwiperInstance) return;
            cloudSwiperInstance.destroy(true, true);
            cloudSwiperInstance = null;
        } else {
            cloudSwiperInstance?.destroy(true, true);
            cloudSwiperInstance = new Swiper(swiperEl, {
                slidesPerView: 1.5,
                spaceBetween: 15,
                speed: 500,
                loop: false,
                centeredSlides: true,
                centerInsufficientSlides: true,
                observer: true,
                observeParents: true,
                resizeObserver: true,
                watchOverflow: false,
                on: {
                    init: updateSlide
                }
            });
        }
    };

    const init = () => {
        initCloudSwiper();
    };

    document.addEventListener('DOMContentLoaded', init);
    mq.addEventListener('change', initCloudSwiper);

    if (Shopify.designMode) {
        ['shopify:section:load', 'shopify:block:select'].forEach((event) =>
            document.addEventListener(event, init)
        );
    }
})();